import { reduce } from "lodash";

export function isCurrentlyEditing(currentlyEditing, possibleCurrentlyEditing) {
  return !!currentlyEditing && reduce(possibleCurrentlyEditing, (result, value, key) => result && currentlyEditing[key] === value, true);
}
